<template>
    <div>
        <v-select
                :items="events.items"
                :loading="loading"
                :disabled="disabled"
                v-model="selectedEvent"
                :label="$t('event')"
                item-value="id"
                item-text="name"
                return-object=""
                @input="$emit('input', selectedEvent)"
                v-if="!selectedEvent"
        >
        </v-select>

        <h2 v-else>{{ eventName }}</h2>

        <v-card v-if="selectedEvent !== null" flat>
            <v-card-title><h4>Turnierdetails</h4></v-card-title>
            <v-divider></v-divider>
            <v-container fluid grid-list-xs>
                <v-layout row wrap>
                    <v-flex xs12 md4>
                        <v-list dense>
                            <v-list-tile>
                                <v-list-tile-content>Location:</v-list-tile-content>
                                <v-list-tile-content class="align-end"><b>{{ selectedEvent.host }}</b></v-list-tile-content>
                            </v-list-tile>
                            <v-list-tile>
                                <v-list-tile-content>Datum:</v-list-tile-content>
                                <v-list-tile-content class="align-end"><b>{{ $formatDate(selectedEvent.start) }}</b></v-list-tile-content>
                            </v-list-tile>
                        </v-list>
                    </v-flex>
                    <v-flex xs12 md4>
                        <v-list dense>
                            <v-list-tile>
                                <v-list-tile-content>{{ $t('first_price') }}:</v-list-tile-content>
                                <v-list-tile-content class="align-end"><b>{{ selectedEvent.current_price.price_string }}</b></v-list-tile-content>
                            </v-list-tile>
                            <v-list-tile>
                                <v-list-tile-content>{{ $t('price_reduced') }}:</v-list-tile-content>
                                <v-list-tile-content class="align-end"><b>{{ selectedEvent.current_price.price_reduced_string }}</b></v-list-tile-content>
                            </v-list-tile>
                        </v-list>
                    </v-flex>
                    <v-flex xs12 md4>
                        <v-list dense>
                            <v-list-tile>
                                <v-list-tile-content>Straße:</v-list-tile-content>
                                <v-list-tile-content class="align-end"><b>{{ selectedEvent.street + ' ' + selectedEvent.street_number }}</b></v-list-tile-content>
                            </v-list-tile>
                            <v-list-tile>
                                <v-list-tile-content>Ort:</v-list-tile-content>
                                <v-list-tile-content class="align-end"><b>{{ selectedEvent.postcode + ' ' + selectedEvent.town }}</b></v-list-tile-content>
                            </v-list-tile>
                        </v-list>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-card>
    </div>
</template>

<script>
    export default {
        props: {
            events: {
                type: Object,
                default: {}
            },
            loading: {
                type: Boolean,
                default: false
            },
            disabled: {
                type: Boolean,
                default: false
            },
            value: {
                type: Object,
                default: null
            }
        },
        data: () => ({
            selectedEvent: null
        }),
        computed: {
            eventName() {
                return this.selectedEvent ? this.selectedEvent.name : '';
            }
        },
        watch: {
            value() {
                this.selectedEvent = this.value;
            }
        }
    }
</script>
